import { OrderProductsTestIds } from '../../../../../utils/testIds/OrderProducts.testIds';
import { OrderProductGridItem } from '../../orderProducts.types';
import OrderProductPriceV2 from './OrderProductPriceV2';

type OrderProductTotalsProps = {
  grid: OrderProductGridItem[];
  partsQuantity: number;
  total: number;
  combinationKey?: string;
  isFinishedOrder: boolean;
};

const OrderProductTotals = ({
  grid,
  partsQuantity,
  total,
  combinationKey,
  isFinishedOrder,
}: OrderProductTotalsProps) => {
  if (!grid.length) {
    return null;
  }

  return (
    <OrderProductPriceV2
      grid={grid}
      isFinishedOrder={isFinishedOrder}
      partsQuantity={partsQuantity}
      combinationKey={combinationKey}
      total={total}
      originalPriceTestId={OrderProductsTestIds.PRICE_ORIGINAL}
      discountedPriceTestId={OrderProductsTestIds.PRICE_DISCOUNTED}
    />
  );
};

export default OrderProductTotals;
